import React, {useState, useEffect, useCallback} from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {api} from './api'
import Auth from './Auth'
import Today from './Today'
import History from './History'
import Foods from './Foods'
import Settings from './Settings'
import Nav from './Nav'
import './styles.css'

const App = () => {
  const [user, setUser] = useState(null) // null = logged out / unknown
  const [ready, setReady] = useState(false)

  const refresh = useCallback(async () => {
    try {
      const me = await api.me()
      setUser(me.authed ? me : null)
    } catch (e) {
      setUser(null)
    } finally {
      setReady(true)
    }
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  if (!ready) return <div className="splash">yoked</div>
  if (!user) return <Auth onAuthed={setUser} />

  return (
    <Router>
      <div className="app">
        <div className="screen">
          <Switch>
            <Route exact path="/">
              <Today user={user} />
            </Route>
            <Route path="/history">
              <History />
            </Route>
            <Route path="/foods">
              <Foods />
            </Route>
            <Route path="/settings">
              <Settings user={user} onUser={setUser} onLogout={() => setUser(null)} />
            </Route>
          </Switch>
        </div>
        <Nav />
      </div>
    </Router>
  )
}

const root = ReactDOM.createRoot(document.getElementById('app'))
root.render(<App />)
module?.hot?.accept()

// register the service worker (enables install-to-home-screen; it does not cache)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}))
}

